import {DefaultFieldWindow} from "./DefaultFieldWindow";
import {Field, Form, FormParticipant} from "../Form";
import {SelectFieldWindow} from "./SelectFieldWindow";
import {NumberFieldWindow} from "./NumberFieldWindow";
import {
	checkbox,
	datefield,
	datetimecolumn,
	numberfield,
	radio,
	select,
	textarea,
	textfield,
	RadioType,
	checkboxgroup,
	Form as GouiForm, timefield,Field as GouiField
} from "@intermesh/goui";
import {DateFieldWindow} from "./DateFieldWindow";
import {LikertFieldWindow} from "./LikertFieldWindow";

export const FieldWindowMap = {
	text: DefaultFieldWindow,
	number: NumberFieldWindow,
	select: SelectFieldWindow,
	checkbox: DefaultFieldWindow,

	textarea: DefaultFieldWindow,
	likert: LikertFieldWindow,
	datetime: DateFieldWindow,
	time: DefaultFieldWindow
}

export type FieldWindowMapType = typeof FieldWindowMap;

export function createFieldWindow<K extends keyof FieldWindowMapType> (type: K, form: Form): InstanceType<FieldWindowMapType[K]> {
	return new FieldWindowMap[type](form, type) as InstanceType<FieldWindowMapType[K]>;
}

const getDefaultFieldConfig = (field:Field, formParticipant: FormParticipant) => {
	return {
		name: field.name,
		label: field.label,
		hint: field.hint,
		required: field.required,
		value: formParticipant.answers?.[field.name] ?? undefined
	};
}


export const FieldEditorMap = {
	text: (field:Field, formParticipant: FormParticipant) => {
		return textfield(getDefaultFieldConfig(field, formParticipant));
	},
	number: (field:Field, formParticipant: FormParticipant) => {
		return numberfield(Object.assign(getDefaultFieldConfig(field, formParticipant), field.options));
	},
	select: (field:Field, formParticipant: FormParticipant) => {
		return select(Object.assign(getDefaultFieldConfig(field, formParticipant), {options: field.options.options.map((o:any) => {return {value: o, name: o}; })}));
	},
	checkbox: (field:Field, formParticipant: FormParticipant) => {
		return checkbox(getDefaultFieldConfig(field, formParticipant));
	},

	textarea: (field:Field, formParticipant: FormParticipant) => {
		return textarea(Object.assign(getDefaultFieldConfig(field, formParticipant), {autoHeight: true}));
	},
	likert: (field:Field, formParticipant: FormParticipant) => {

		return radio(Object.assign(getDefaultFieldConfig(field, formParticipant), {type: "box" as RadioType, options: field.options.options.map((o:any, index: number) => {return {value: index + 1, text: o}; })}));
	},
	datetime: (field:Field, formParticipant: FormParticipant) => {
		return datefield(Object.assign(getDefaultFieldConfig(field, formParticipant), field.options));
	},

	time: (field:Field, formParticipant: FormParticipant) => {
		return timefield(getDefaultFieldConfig(field, formParticipant));
	},

}

export function createFieldEditor(field: Field, formParticipant: FormParticipant) : GouiField {
	return FieldEditorMap[field.type](field, formParticipant);
}
